export const MAGICIAN_FIRST_RESPONSE_TAG = 'x-response-magician-first'
export const MAGICIAN_SECOND_RESPONSE_TAG = 'x-response-magician-second'

type ActionInputs = Record<string, string | number>

export interface MagicianResponseOption {
  tag: string
  possibleValues: Array<string | number>
  dbAction: string
  optional?: boolean
}

function toSelection(value: string | number | undefined): number | undefined {
  if (value === undefined || value === '') {
    return undefined
  }
  const numeric = Number(value)
  return Number.isFinite(numeric) ? numeric : undefined
}

export function hasInvalidMagicianPairSelection(inputs: ActionInputs): boolean {
  const first = toSelection(inputs[MAGICIAN_FIRST_RESPONSE_TAG])
  const second = toSelection(inputs[MAGICIAN_SECOND_RESPONSE_TAG])
  if (first === undefined || second === undefined) {
    return false
  }

  const firstSkips = first === -1
  const secondSkips = second === -1
  return firstSkips !== secondSkips || (!firstSkips && first === second)
}

export function constrainMagicianResponseOption<
  T extends MagicianResponseOption,
>(option: T, inputs: ActionInputs): T {
  const otherTag
    = option.tag === MAGICIAN_FIRST_RESPONSE_TAG
      ? MAGICIAN_SECOND_RESPONSE_TAG
      : option.tag === MAGICIAN_SECOND_RESPONSE_TAG
        ? MAGICIAN_FIRST_RESPONSE_TAG
        : null
  if (!otherTag) {
    return option
  }

  const other = toSelection(inputs[otherTag])
  if (other === undefined) {
    return option
  }

  return {
    ...option,
    possibleValues: option.possibleValues.filter(
      value => other <= 0 || Number(value) !== other,
    ),
  } as T
}

export function getMagicianActionLabelKey(tag: string): string | null {
  if (tag === MAGICIAN_FIRST_RESPONSE_TAG) {
    return 'actions.action_magician_swap_first'
  }
  if (tag === MAGICIAN_SECOND_RESPONSE_TAG) {
    return 'actions.action_magician_swap_second'
  }
  return null
}
